import Vue from 'vue';
import PouchVue from 'pouch-vue';
import PouchDB from 'pouchdb-browser';
import PouchFind from 'pouchdb-find';
import PouchLiveFind from 'pouchdb-live-find';
// import PouchDebug from 'pouchdb-debug'

PouchDB.plugin(PouchFind);
PouchDB.plugin(PouchLiveFind);
// PouchDB.plugin(PouchDebug);

const options = {
  revs_limit: 1
};
if (!global.isWeb) {
  // PouchDB.plugin(require('pouchdb-adapter-cordova-sqlite'));
  // options.adapter = 'cordova-sqlite';
}

Vue.use(PouchVue, {
  pouch: PouchDB,
  defaultDB: 'appologic',
  optionsDB: options
  // debug: '*'
});
